import { BrandsList } from "../Brands";
import { CtaButtonsComponent, CtaType } from "../CtaButton";
import { IndustryTestimonialCarousel } from "../IndustryTestimonialCarousel";


type ProductHomeHeroProps = {
    title: string;
    subtitle: string;
    description: string;
    ctas: CtaType[];
    heroImage: { src: string; alt: string };
    brandsTitle: string;
    brands: { src: string; alt: string }[];
  };

export function ProductHomeHero({ title, subtitle, description, ctas, brandsTitle, brands }: ProductHomeHeroProps) {
    return (
        <>
            <div className="section_industry-header bg-[var(--pink--50)] dark:bg-[var(--pink--800)]">
                <div className="padding-global">
                    <div className="container-large">
                        <div className="industry-header_component">
                            <div className="industry-header_content-top">
                                <div className="max-width-xlarge align-center">
                                    <div className="industry-header_title w-richtext">
                                        <h1 className="text-black dark:text-white">
                                            <strong>{title} </strong>
                                            {subtitle}
                                        </h1>
                                    </div>
                                    <div className="padding-bottom padding-xsmall"></div>
                                    <div className="max-width-large align-center">
                                        <p className="text-size-medium" dangerouslySetInnerHTML={{__html: description}} />
                                    </div>
                                    <div className="padding-bottom padding-small"></div>
                                    <div className="button-row is-centered-buttons">
                                        <CtaButtonsComponent ctas={ctas} />
                                    </div>
                                    <div className="padding-bottom padding-xhuge w-condition-invisible"></div>
                                </div>
                            </div>
                            <div className="industry-header_content-bottom">
                                <div className="industry-header_image-wrapper">
                                    <IndustryTestimonialCarousel />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="industry-header_border-bottom bg-[var(--pink--50)] dark:bg-[var(--pink--800)]"></div>
            </div>

            <BrandsList brands={brands} brandsTitle={brandsTitle}/>
        </>
    )
}